import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { FormFieldFileUpload } from '@publishing-engine/domain/types/article';

type IProps = {
  fieldLabels: FormFieldFileUpload['params']['labels'];
  editCallback?: () => void;
};

export const FundingEmptyState: React.FC<IProps> = ({
  fieldLabels,
  editCallback
}) => (
  <Flex
    flexDirection={'column'}
    backgroundColor={'surfaceTertiaryFill'}
    padding={4}
  >
    <Flex alignItems="center" gap={2} flexDirection="row">
      <Text textStyle="textBody">No {fieldLabels?.main} provided</Text>
    </Flex>
    <Flex>
      {editCallback && <ButtonText onClick={editCallback}>Update</ButtonText>}
    </Flex>
  </Flex>
);
